import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasToastProvider } from '../../shared/kit';
import App from './App';
import type { AgendaInitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-agenda-app');

if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: AgendaInitData | null = null;
    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as AgendaInitData;
    } catch (error) {
        mountEl.textContent = 'Agenda : données initiales invalides.';
        throw error;
    }

    createRoot(mountEl).render(
        <React.StrictMode>
            <GasToastProvider>
                <App initData={initData} />
            </GasToastProvider>
        </React.StrictMode>,
    );
}
